import axios from "axios";
import { useState } from "react";
import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import { root_url } from "../setting";
import { getBearerString } from "../utils/Auth";

const AdminRecord = () => {
  const [info, setInfo] = useState({});
  const [result, setResult] = useState([]);

  // 검색버튼
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("clicked");
    // if(info.ticketName === undefined || info.ticketName === '' || info.gender === undefined || info.gender === ''){
    //   alert('검색 항목을 선택해주세요!');
    //   return ;
    // }
    // if((info.ticketName !== undefined && info.ticketName === '10Km') && (info.gender === undefined || info.gender === '')){
    //   alert('성별을 선택해주세요!');
    //   return ;
    // }
    // if((info.ticketName !== undefined && info.ticketName === '18Km') && (info.gender === undefined && info.gender === '')){
    //   alert('성별을 선택해주세요!');
    //   return ;
    // }
    let accessToken = getBearerString();
    let headers = {
      Authorization: accessToken,
    };
    try {
      let response = await axios.post(
        `${root_url}/api/admin/untact/rank`,
        info,
        headers
      );
      setResult(response.data);
      console.log(response.data);
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 403) {
        alert("권한이 존재하지 않습니다.");
        localStorage.setItem("accessToken", "");
        window.location.href = "/admin/login";
      }
    }
  };

  return (
    <Container>
      <h1 id="outline" className="mt-5 pt-3 text-center">
        순위 확정
      </h1>
      <Form inline onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col>
            <Form.Control
              as="select"
              onChange={(e) => {
                let ticketName = e.target.value;
                setInfo({ ...info, ticketName: ticketName });
              }}
            >
              <option value="">종목</option>
              <option value={"10Km"}>10Km</option>
              <option value={"18Km"}>18Km</option>
            </Form.Control>
          </Col>

          <Col>
            <Form.Control
              as="select"
              className="my-1 mr-sm-2"
              id="inlineFormCustomSelectPref"
              custom
              onChange={(e) => {
                let gender = e.target.value;
                setInfo({ ...info, gender: gender });
              }}
            >
              <option value="">성별</option>
              <option value="M">남자</option>
              <option value="F">여자</option>
            </Form.Control>
          </Col>
          <Col>
            <Button className="me-4" type="submit">
              검색
            </Button>
          </Col>
          <Col>
            <Form.Group style={{ display: "flex" }}>
              <Form.Control
                type="date"
                id=""
                onChange={(e) => {
                  let confirmDate = e.target.value;
                  setInfo({ ...info, confirmDate: confirmDate });
                }}
              />
            </Form.Group>
          </Col>
          <Col className="col-2">
            <Button
              className="me-4"
              onClick={async () => {
                // 순위 확정
                try {
                  if (info.ticketName === undefined || info.ticketName === "") {
                    alert("종목을 선택해주세요.");
                    return;
                  }
                  if (
                    info.ticketName !== undefined &&
                    info.ticketName === "10Km" &&
                    (info.gender === undefined || info.gender === "")
                  ) {
                    alert("성별을 선택해주세요.");
                    return;
                  }
                  if (
                    info.ticketName !== undefined &&
                    info.ticketName === "18Km" &&
                    info.gender === undefined &&
                    info.gender === ""
                  ) {
                    alert("성별을 선택해주세요.");
                    return;
                  }
                  let tmpArr = [];
                  result.map((item, key) => {
                    tmpArr.push({
                      backNo: item.backNo,
                      rankNo: item.rankNo,
                      confirmTime: info.confirmDate,
                    });
                  });
                  console.log(tmpArr);
                  let accessToken = getBearerString();
                  let headers = {
                    Authorization: accessToken,
                  };
                  let response = await axios.post(
                    `${root_url}/api/admin/untact/announce`,
                    tmpArr,
                    headers
                  );
                  console.log(info);

                  alert("성공했습니다.");
                } catch (error) {
                  if (error?.response?.status === 403) {
                    alert("권한이 존재하지 않습니다.");
                    localStorage.setItem("accessToken", "");
                    window.location.href = "/admin/login";
                  }
                  alert("error", error);
                  console.log(error);
                }
              }}
            >
              순위확정
            </Button>
          </Col>
        </Row>
      </Form>
      <Table bordered className="text-center" style={{ minWidth: "700px" }}>
        <thead>
          <tr style={{ color: "white" }} className="bg-custom-color">
            <th>임시 순위</th>
            <th>참가 종목</th>
            <th>성별</th>
            <th>확정 순위</th>
            <th>이름</th>
            <th>배번호</th>
            <th>출발시간</th>
            <th>완주시간</th>
            <th>소요시간</th>
          </tr>
        </thead>
        <tbody>
          {result.map((item, key) => {
            return (
              <tr key={key}>
                <td>{item.rankNo}</td>
                <td>{item.ticketName}</td>
                <td>{item.gender === "M" ? "남자" : "여자"}</td>
                <td>{item.totalRank}</td>
                <td>{item.runnerName}</td>
                <td>{item.backNo}</td>
                <td>{(item.startTime + "").split("T")[1]}</td>
                <td>{(item.finishTime + "").split("T")[1]}</td>
                <td>{item.elapseTime}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Container>
  );
};

export default AdminRecord;
